import { c as _c } from "react/compiler-runtime";
import { SkeletonLoader } from "@/components/ui/skeleton";
interface SellerUnitOneSkeletonProps {
  className?: string;
  isInModal?: boolean;
}
export function SellerUnitOneSkeleton(t0) {
  const $ = _c(40);
  const {
    className: t1,
    isInModal: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const isInModal = t2 === undefined ? false : t2;
  const t3 = `@container ${className} min-h-screen bg-white max-w-7xl mx-auto`;
  let t4;
  if ($[0] !== isInModal) {
    t4 = !isInModal && <div className="mt-6 mb-4 px-2 @4xl:px-0"><div className="flex items-center gap-2"><SkeletonLoader height="16px" width="60px" /><span className="text-gray-400">/</span><SkeletonLoader height="16px" width="80px" /><span className="text-gray-400">/</span><SkeletonLoader height="16px" width="120px" /></div></div>;
    $[0] = isInModal;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SkeletonLoader height="32px" width="70%" />;
    t6 = <SkeletonLoader height="20px" width="50%" />;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-4 mb-6 px-2 @4xl:px-0 space-y-3">{t5}{t6}<div className="flex items-center gap-4"><SkeletonLoader height="24px" width="120px" /><SkeletonLoader height="20px" width="80px" /></div></div>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t4) {
    t8 = <div className="px-0 @4xl:px-4">{t4}{t7}</div>;
    $[5] = t4;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mb-3 h-[300px] -mx-0 @4xl:-mx-4"><SkeletonLoader height="300px" width="100%" className="rounded-none" /></div>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  let t11;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SkeletonLoader height="28px" width="40%" />;
    t11 = <SkeletonLoader height="20px" width="60%" />;
    $[8] = t10;
    $[9] = t11;
  } else {
    t10 = $[8];
    t11 = $[9];
  }
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="@4xl:hidden mt-4">{t9}<div className="px-2 space-y-4">{t10}{t11}<div className="grid grid-cols-2 gap-4"><SkeletonLoader height="60px" width="100%" /><SkeletonLoader height="60px" width="100%" /></div><SkeletonLoader height="48px" width="100%" /></div></div>;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="@4xl:col-span-2 min-h-[500px]"><SkeletonLoader height="500px" width="100%" /></div>;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  let t15;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SkeletonLoader height="28px" width="60%" />;
    t15 = <SkeletonLoader height="20px" width="80%" />;
    $[12] = t14;
    $[13] = t15;
  } else {
    t14 = $[12];
    t15 = $[13];
  }
  let t16;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="hidden @4xl:block mt-4"><div className="grid grid-cols-1 @4xl:grid-cols-3 gap-8 mb-8">{t13}<div className="@4xl:col-span-1 space-y-4">{t14}{t15}<div className="space-y-3"><SkeletonLoader height="60px" width="100%" /><SkeletonLoader height="60px" width="100%" /><SkeletonLoader height="48px" width="100%" /></div></div></div></div>;
    $[14] = t16;
  } else {
    t16 = $[14];
  }
  let t17;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SkeletonLoader height="24px" width="120px" className="mb-4" />;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  let t18;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="mb-8 px-2 @4xl:px-0">{t17}<div className="mb-3 h-[300px] @4xl:h-[800px] -mx-4"><SkeletonLoader height="100%" width="100%" className="rounded-none" /></div></div>;
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SkeletonLoader height="24px" width="140px" />;
    $[17] = t19;
  } else {
    t19 = $[17];
  }
  let t20;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="space-y-4">{t19}<div className="space-y-3">{[...Array(6)].map(_temp)}</div></div>;
    $[18] = t20;
  } else {
    t20 = $[18];
  }
  let t21;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SkeletonLoader height="24px" width="120px" />;
    $[19] = t21;
  } else {
    t21 = $[19];
  }
  let t22;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="grid grid-cols-1 @4xl:grid-cols-2 gap-8 mb-8 px-2 @4xl:px-0">{t20}<div className="space-y-4">{t21}<div className="space-y-3">{[...Array(6)].map(_temp2)}</div></div></div>;
    $[20] = t22;
  } else {
    t22 = $[20];
  }
  let t23;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <SkeletonLoader height="24px" width="100px" className="mb-4" />;
    $[21] = t23;
  } else {
    t23 = $[21];
  }
  let t24;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="mb-8 px-2 @4xl:px-0">{t23}<div className="grid grid-cols-2 @4xl:grid-cols-4 gap-4">{[...Array(8)].map(_temp3)}</div></div>;
    $[22] = t24;
  } else {
    t24 = $[22];
  }
  let t25;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SkeletonLoader height="24px" width="160px" className="mb-4" />;
    $[23] = t25;
  } else {
    t25 = $[23];
  }
  let t26;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="mb-8 px-2 @4xl:px-0">{t25}<div className="space-y-2">{[...Array(4)].map(_temp4)}</div></div>;
    $[24] = t26;
  } else {
    t26 = $[24];
  }
  let t27;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <SkeletonLoader height="24px" width="80px" />;
    $[25] = t27;
  } else {
    t27 = $[25];
  }
  let t28;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="space-y-4">{t27}<div className="space-y-2">{Array.from({
          length: 3
        }, _temp5)}</div></div>;
    $[26] = t28;
  } else {
    t28 = $[26];
  }
  let t29;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <SkeletonLoader height="24px" width="80px" />;
    $[27] = t29;
  } else {
    t29 = $[27];
  }
  let t30;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="grid grid-cols-1 @4xl:grid-cols-2 gap-8 mb-8 px-2 @4xl:px-0">{t28}<div className="space-y-4">{t29}<div className="space-y-2">{Array.from({
            length: 3
          }, _temp6)}</div></div></div>;
    $[28] = t30;
  } else {
    t30 = $[28];
  }
  let t31;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SkeletonLoader height="24px" width="120px" className="mb-4" />;
    $[29] = t31;
  } else {
    t31 = $[29];
  }
  let t32;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="mb-8 px-2 @4xl:px-0">{t31}<div className="grid grid-cols-1 @4xl:grid-cols-2 gap-4">{[...Array(2)].map(_temp7)}</div></div>;
    $[30] = t32;
  } else {
    t32 = $[30];
  }
  let t33;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="px-0 @4xl:px-4">{t12}{t16}{t18}{t22}{t24}{t26}{t30}{t32}<div className="mb-8 px-2 @4xl:px-0"><SkeletonLoader height="24px" width="120px" className="mb-4" /><SkeletonLoader height="400px" width="100%" /></div></div>;
    $[31] = t33;
  } else {
    t33 = $[31];
  }
  let t34;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <SkeletonLoader height="24px" width="160px" className="mb-4" />;
    $[32] = t34;
  } else {
    t34 = $[32];
  }
  let t35;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="mb-8 px-2 @4xl:px-0">{t34}<div className="flex gap-4 overflow-hidden">{[...Array(3)].map(_temp8)}</div></div>;
    $[33] = t35;
  } else {
    t35 = $[33];
  }
  let t36;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <SkeletonLoader height="24px" width="140px" className="mb-4" />;
    $[34] = t36;
  } else {
    t36 = $[34];
  }
  let t37;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="mb-8 px-2 @4xl:px-0">{t36}<div className="flex gap-4 overflow-hidden">{[...Array(3)].map(_temp9)}</div></div>;
    $[35] = t37;
  } else {
    t37 = $[35];
  }
  let t38;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div className="px-0 @4xl:px-4">{t35}{t37}<div className="px-2 @4xl:px-0 py-1 border-t border-gray-200"><SkeletonLoader height="12px" width="100%" className="mb-1" /><SkeletonLoader height="12px" width="90%" className="mb-1" /><SkeletonLoader height="12px" width="95%" /></div></div>;
    $[36] = t38;
  } else {
    t38 = $[36];
  }
  let t39;
  if ($[37] !== t3 || $[38] !== t8) {
    t39 = <div className={t3}>{t8}{t33}{t38}</div>;
    $[37] = t3;
    $[38] = t8;
    $[39] = t39;
  } else {
    t39 = $[39];
  }
  return t39;
}
function _temp9(__7, index_7) {
  return <div key={index_7} className="flex-shrink-0 w-80"><div className="border border-gray-200 rounded-lg p-4"><SkeletonLoader height="200px" width="100%" className="mb-4" /><SkeletonLoader height="20px" width="60%" className="mb-2" /><SkeletonLoader height="16px" width="80%" className="mb-2" /><div className="flex gap-2"><SkeletonLoader height="16px" width="40px" /><SkeletonLoader height="16px" width="40px" /><SkeletonLoader height="16px" width="40px" /></div></div></div>;
}
function _temp8(__6, index_6) {
  return <div key={index_6} className="flex-shrink-0 w-80"><div className="border border-gray-200 rounded-lg p-4"><SkeletonLoader height="200px" width="100%" className="mb-4" /><SkeletonLoader height="20px" width="60%" className="mb-2" /><SkeletonLoader height="16px" width="80%" className="mb-2" /><div className="flex gap-2"><SkeletonLoader height="16px" width="40px" /><SkeletonLoader height="16px" width="40px" /><SkeletonLoader height="16px" width="40px" /></div></div></div>;
}
function _temp7(__5, index_5) {
  return <div key={index_5} className="border border-gray-200 rounded-lg p-4"><SkeletonLoader height="20px" width="60%" className="mb-2" /><SkeletonLoader height="16px" width="40%" className="mb-2" /><SkeletonLoader height="16px" width="50%" /></div>;
}
function _temp6(__4, index_4) {
  return <SkeletonLoader key={index_4} height="16px" width={`${[60, 75, 85][index_4]}%`} />;
}
function _temp5(__3, index_3) {
  return <SkeletonLoader key={index_3} height="16px" width={`${[65, 80, 70][index_3]}%`} />;
}
function _temp4(__2, index_2) {
  return <SkeletonLoader key={index_2} height="16px" width={`${[70, 85, 75, 80][index_2]}%`} />;
}
function _temp3(__1, index_1) {
  return <div key={index_1} className="flex items-center gap-2"><SkeletonLoader height="20px" width="20px" /><SkeletonLoader height="16px" width="80px" /></div>;
}
function _temp2(__0, index_0) {
  return <div key={index_0} className="flex justify-between"><SkeletonLoader height="16px" width="40%" /><SkeletonLoader height="16px" width="30%" /></div>;
}
function _temp(_, index) {
  return <div key={index} className="flex justify-between"><SkeletonLoader height="16px" width="40%" /><SkeletonLoader height="16px" width="30%" /></div>;
}